import React from "react";

import Tabela from "../comum/Tabela";
import { reais } from "../comum/formato";
import { STATUS_CAMPANHA, retornoX } from "./api";

export default function TabelaCampanhas({ campanhas, onAbrir }) {
  const colunas = [
    { id: "nome", rotulo: "Campanha", valor: (c) => c.nome, render: (c) => (
      <div className="min-w-0"><b className="block truncate max-w-[260px]">{c.nome}</b>
        {c.meta_campaign_id && <span className="text-[10px] text-muted-foreground tabular-nums">{c.meta_campaign_id}</span>}</div>) },
    { id: "status", rotulo: "Status", valor: (c) => c.status, render: (c) => { const [r, cor] = STATUS_CAMPANHA[c.status] || [c.status, "text-muted-foreground"]; return <span className={`text-xs ${cor}`}>{r}</span>; } },
    { id: "investido", rotulo: "Investido", alinhar: "direita", valor: (c) => c.investido, render: (c) => reais(c.investido) },
    { id: "cliques", rotulo: "Cliques", alinhar: "direita", valor: (c) => c.cliques, render: (c) => c.cliques.toLocaleString("pt-BR") },
    { id: "pedidos", rotulo: "Pedidos", alinhar: "direita", valor: (c) => c.pedidos, render: (c) => <b>{c.pedidos}</b> },
    { id: "faturado", rotulo: "Faturado", alinhar: "direita", valor: (c) => c.faturado, render: (c) => reais(c.faturado) },
    { id: "cpp", rotulo: "Custo/pedido", alinhar: "direita", valor: (c) => c.custo_por_pedido, render: (c) => (c.custo_por_pedido == null ? "—" : reais(c.custo_por_pedido)) },
    { id: "lucro", rotulo: "Lucro após anúncio", alinhar: "direita", valor: (c) => c.lucro_depois_anuncio, render: (c) => (c.lucro_depois_anuncio == null ? <span className="text-muted-foreground">—</span>
      : <span className={c.lucro_depois_anuncio < 0 ? "text-red-500" : "text-emerald-600 dark:text-emerald-400"}>{reais(c.lucro_depois_anuncio)}</span>) },
    { id: "retorno", rotulo: "ROI", alinhar: "direita", valor: (c) => c.retorno, render: (c) => <b>{retornoX(c.retorno)}</b> },
  ];
  return (
    <section className="rounded-xl border bg-card p-4 sm:p-5">
      <h3 className="font-semibold mb-2">Por campanha</h3>
      <Tabela colunas={colunas} linhas={campanhas} ordemInicial={{ id: "investido", desc: true }} onClicar={onAbrir}
        vazio="Nenhuma campanha com gasto ou pedido no período." e2e="tabela-campanhas-meta" chave={(c) => c.chave} />
      <p className="text-[11px] text-muted-foreground mt-2">Clique numa campanha para ver os anúncios, os produtos vendidos e os pedidos.</p>
    </section>
  );
}
